// extracted by mini-css-extract-plugin
export default {"h":"Header_h__PHp4z","l":"Header_l__w5W+E","t":"Header_t__NDgGL","s":"Header_s__t+L4c","b":"Header_b__FebQp"};